module.exports = __webpack_public_path__ + "img/financial-analysis-laptop.13efed81.png";